// home-network.js — the postal finder in the homepage "National inventory.
// Local stores." band (home-network.liquid).
//
// Without scripting the finder GETs the store locator. With scripting it is
// answered in place: the section renders one card per store (all but the
// default hidden) and TMG_STORE_MATCH (store-match.js, loaded by the
// header) picks which shows. A match shows that store's card with the
// section's "after a postal code" eyebrow ([km], [code]); no match shows
// the default card with a head-office line; invalid input asks again.
// Cards find their store by data-store-name.
//
// Matches made elsewhere (e.g. the header flyout) arrive as tmg:store and
// persist across pages. The theme editor ignores the saved match; selecting
// a store block there shows its card.
//
// Same guard + rescan() pattern as header.js / locator.js.
if (!window.__tmgNetwork) {
  (function () {
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    function say(root, text) {
      var msg = root.querySelector('[data-store-msg]');
      if (msg) msg.textContent = text || '';
    }

    // Shows `card`, hides the rest, and gives the shown card the match
    // eyebrow when `r` is a match (every other card keeps its own).
    function showCard(root, card, r) {
      var M = window.TMG_STORE_MATCH;
      root.querySelectorAll('[data-store-card]').forEach(function (c) {
        c.hidden = c !== card;
        var tag = c.querySelector('[data-store-eyebrow]');
        if (!tag) return;
        if (!tag.hasAttribute('data-default-text')) tag.setAttribute('data-default-text', tag.textContent);
        var text = tag.getAttribute('data-default-text');
        if (c === card && r && r.store && M) {
          text = M.fill(root.getAttribute('data-eyebrow-match'), r, c.getAttribute('data-store-name')) || text;
        }
        tag.textContent = text;
        tag.hidden = !text;
      });
    }

    function show(root, r) {
      var M = window.TMG_STORE_MATCH;
      var cards = root.querySelectorAll('[data-store-card]');
      if (!cards.length) return;
      var card = null;
      if (r && r.store && M) {
        cards.forEach(function (c) {
          if (!card && M.keyOf(c.getAttribute('data-store-name')) === r.store) card = c;
        });
      }
      var fallback = root.querySelector('[data-store-card][data-store-default]') || cards[0];
      showCard(root, card || fallback, card ? r : null);
    }

    function onSubmit(e) {
      var M = window.TMG_STORE_MATCH;
      var form = e.currentTarget;
      var root = form.closest('[data-store-finder]');
      var field = form.querySelector('input[name="postal"]');
      if (!M || !root || !field) return; // no matcher: the GET to the locator answers instead
      e.preventDefault();

      var r = M.match(field.value);
      if (!r) {
        say(root, root.getAttribute('data-msg-invalid'));
        field.focus();
        return;
      }
      M.save(r); // fires tmg:store, which runs show() on every band on the page

      var shown = root.querySelector('[data-store-card]:not([hidden])');
      var name = r.name;
      if (shown && r.store && M.keyOf(shown.getAttribute('data-store-name')) === r.store) {
        name = shown.getAttribute('data-store-name');
      }
      say(root, M.fill(root.getAttribute(r.store ? 'data-msg-match' : 'data-msg-outside'), r, name));
    }

    function onStore(e) {
      document.querySelectorAll('[data-store-finder]').forEach(function (root) {
        show(root, e.detail);
      });
    }

    function onBlockSelect(e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-store-card]') : null;
      var root = card ? card.closest('[data-store-finder]') : null;
      if (root) showCard(root, card, null);
    }

    function bind() {
      var M = window.TMG_STORE_MATCH;
      var r = M && !designMode() ? M.saved() : null;
      document.querySelectorAll('[data-store-finder]').forEach(function (root) {
        var form = root.querySelector('[data-store-form]');
        if (form && !form.dataset.storeBound) {
          form.dataset.storeBound = '1';
          form.addEventListener('submit', onSubmit);
        }
        if (r) show(root, r);
      });
    }

    document.addEventListener('tmg:store', onStore);
    document.addEventListener('shopify:section:load', function () {
      window.__tmgNetwork.rescan();
    });
    document.addEventListener('shopify:block:select', onBlockSelect);

    bind();
    window.__tmgNetwork = { rescan: bind };
  })();
}
